export default function PrivacyPage() {
  return (
    <div className="legal-page">
      <h1>Privacy Policy</h1>
      <p className="legal-updated">Last Updated: February 27, 2026</p>

      <h2>Overview</h2>
      <p>
        Apollo Towing DFW ("we", "us", "our") operates the Apollo Towing DFW dispatch system.
        This Privacy Policy explains how we collect, use, and protect your information.
      </p>

      <h2>Information We Collect</h2>
      <ul>
        <li><strong>Account Information:</strong> Name, phone number, and login credentials for dispatch system users.</li>
        <li><strong>Service Call Data:</strong> Property addresses, vehicle information, contact details, and photos submitted during service calls.</li>
        <li><strong>SMS Data:</strong> Phone numbers used to send and receive dispatch notifications via text message.</li>
      </ul>

      <h2>How We Use Your Information</h2>
      <ul>
        <li>To operate and manage towing dispatch services.</li>
        <li>To send SMS notifications to drivers about new service calls.</li>
        <li>To maintain records of service calls for reporting purposes.</li>
        <li>To communicate with property managers and contacts regarding service requests.</li>
      </ul>

      <h2>SMS/Text Messaging</h2>
      <p>
        By providing your phone number and opting in, you consent to receive dispatch-related
        text messages from Apollo Towing DFW. These messages include new call alerts, dispatch
        updates, and service notifications. Message frequency varies based on call volume.
        Message and data rates may apply.
      </p>
      <p>
        You may opt out of text messages at any time by replying <strong>STOP</strong> to any message.
        Reply <strong>HELP</strong> for assistance. Opting out of SMS will not affect your ability
        to use the dispatch system.
      </p>

      <h2>Data Sharing</h2>
      <p>
        We do not sell, trade, or rent your personal information to third parties. We may share
        information with service providers (such as Twilio for SMS delivery) solely to operate
        our dispatch services.
      </p>

      <h2>Data Security</h2>
      <p>
        We use industry-standard security measures to protect your data, including encrypted
        connections, secure authentication, and access controls based on user roles.
      </p>

      <h2>Data Retention</h2>
      <p>
        Service call records are retained for business and legal purposes. Account information
        is retained while your account is active. You may request deletion of your data by
        contacting us.
      </p>

      <h2>Contact Us</h2>
      <p>
        If you have questions about this Privacy Policy, contact us at:<br />
        <strong>Apollo Towing DFW</strong><br />
        Email: info@apollotowingdfw.com
      </p>
    </div>
  );
}
